import providerConfig, {
    moduleName as providerModuleName,
} from "./Providers/config";
import sellerConfig, { moduleName as sellerModuleName } from "./Seller/config";

import PaymentSaga from "./saga";

import { registerModule } from "moduleConfig";
import { registerProjects } from "rootProjects";
import { registerRoutings } from "rootRouting";
import store from "rootStore";
import { permissionsType, routingType } from "types/configTypes";
import AsyncComponent from "ui/AsyncComponent";
import IConfig from "interfaces/IConfig";
import ProjectContext from "app/App/context";

export const moduleName = "Payment";
export const url = `/payment`;

const getConfig = (permissions: permissionsType, settings: any) => {
    const config: IConfig = {
        active: false,
        routing: [],
        url,
    };
    let routing: routingType = [];

    const routingChildrens = [];

    store.injectSaga?.("PaymentSaga", PaymentSaga);

    // register Sellers module
    const sellers = sellerConfig(permissions, url);
    if (sellers.config.active) {
        config.active = true;

        registerModule(sellerModuleName, sellers.config);
        routingChildrens.push(...sellers.routing);
    }

    // register Providers module
    if (config.active) {
        const providers = providerConfig();
        if (providers.config.active) {
            config.active = true;

            registerModule(providerModuleName, providers.config);
            routingChildrens.push(...providers.routing);
        }
    }

    if (routingChildrens.length) {
        routing.push({
            path: url + "/*",
            children: routingChildrens,
            element: (
                <ProjectContext.Provider value={{ project: "payment", url }}>
                    <AsyncComponent path="Payment/index" />{" "}
                </ProjectContext.Provider>
            ),
        });
    }

    if (config.active) {
        registerProjects([
            {
                id: "payment",
                name: "Payment",
                icon: "payment",
                url: `${url}`,
                priority: 450,
            },
        ]);
    }

    if (routing.length > 0) {
        config.routing = routing.map((item) => item.path);
        registerRoutings(routing);
    }

    return config;
};

export default getConfig;
